// Author: Akarsh Singh | 2026-09-15 | Actionable messages without exposing raw backend exceptions.
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export function apiErrorKey(error: any): string {
  const status = Number(error?.status);
  if (status === 0) return 'API_ERRORS.CONNECTION';
  if (status === 401) return 'API_ERRORS.SESSION';
  if (status === 403) return 'API_ERRORS.PERMISSION';
  if (status === 404) return 'API_ERRORS.NOT_FOUND';
  if (status === 408 || status === 504 || error?.name === 'TimeoutError') return 'API_ERRORS.TIMEOUT';
  if (status === 409) return 'API_ERRORS.CONFLICT';
  if (status === 429) return 'API_ERRORS.BUSY';
  if (error?.error?.errors?.[0]?.code === 'REQUEST_FAILED') return 'API_ERRORS.UNAVAILABLE';
  if (status === 400 || status === 422) return 'API_ERRORS.REQUEST';
  return 'API_ERRORS.UNAVAILABLE';
}

export function apiErrorReference(error: any): string {
  const value = error?.headers?.get?.('x-request-id') || error?.headers?.get?.('x-amzn-requestid') || error?.error?.requestId;
  return typeof value === 'string' && /^[a-zA-Z0-9_-]{8,80}$/.test(value) ? value : '';
}

@Injectable({ providedIn: 'root' })
export class FriendlyApiErrorService {
  constructor(private translate: TranslateService) {}
  describe(error: any, operation = 'API_ERRORS.ACTION'): string {
    const reference = apiErrorReference(error);
    // Only non-sensitive diagnostics: never tokens, request bodies, SQL or raw errors.
    console.warn('[API request failed]', { operation, status: error?.status ?? null, reference: reference || null });
    return this.translate.instant(operation) + ' ' + this.translate.instant(apiErrorKey(error))
      + (reference ? ' ' + this.translate.instant('API_ERRORS.REFERENCE', { reference }) : '');
  }
}
